import { gql } from 'graphql-tag'

export const REMOVE_ADDRESS_IMAGE = gql`
  mutation removeAddressImage($addressId: ID!, $imageType: AddressImageType!) {
    removeAddressImage(addressId: $addressId, imageType: $imageType) {
      addressId
      imageType
      createdAt
      key
      updatedAt
      meta
      tags
    }
  }
`
